import { Icon } from '../atoms';

type ErrorBoxProps = {
  showAlertTriangle?: boolean;
} & React.PropsWithChildren;

export const ErrorBox = (props: ErrorBoxProps) => {
  const { showAlertTriangle } = props;
  return (
    <div className='border border-gray-200 bg-error-25 shadows-xs min-h-[52px] flex p-4 gap-4 text-sm items-center'>
      {showAlertTriangle && (
        <div className='flex items-center justify-center'>
          <Icon type='alert-triangle' size='24' />
        </div>
      )}
      {props.children}
    </div>
  );
};
